class FaqComponent extends HTMLElement {
  constructor() {
    super()

    this.querySelectorAll('.faq-item__question').forEach((question) =>
      question.addEventListener('click', this.onFaqClick.bind(this))
    )
  }

  onFaqClick(event) {
    if (event.currentTarget.classList.contains('active')) {
      event.currentTarget.classList.remove('active')
    } else {
      // Only close other accordions if this is within an accordion-collection-list
      const isAccordionCollectionList = this.closest('.accordion-collection-list-wrapper')

      if (isAccordionCollectionList) {
        // Close all other open accordions
        this.querySelectorAll('.faq-item__question.active').forEach((activeQuestion) => {
          activeQuestion.classList.remove('active')
        })
      }

      // Open the clicked accordion
      event.currentTarget.classList.add('active')
    }
  }
}

customElements.define('faq-component', FaqComponent)
